
import respUtility from '@/mixins/respUtility';

export default {
  name: 'ProductInfoReviewsItemReview',
  mixins: [respUtility],
  props: {
    review: {
      type: Object,
    },
    isProductPage: {
      type: Boolean,
      default: false,
    },
    view3D: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isExpanded: false,
      maxLength: 253,
    };
  },
  computed: {
    isMobile() {
      return this.$device.isMobileOrTablet || this.isTouchDevice;
    },
    needsTruncation() {
      if (this.isProductPage) {
        return false;
      }
      return this.review.summary.length > this.maxLength;
    },
    truncatedText() {
      if (this.isProductPage) {
        return this.review.summary;
      }
      if (this.needsTruncation) {
        return `${this.review.summary.slice(0, this.maxLength)}...`;
      }
      return this.review.summary;
    },
    fullText() {
      return this.review.summary;
    },
  },
};
